import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "首屏", href: "#home" },
  { label: "热门推荐", href: "#hot" },
  { label: "题材分类", href: "#categories" },
  { label: "最新追更", href: "#latest" },
  { label: "品牌口碑", href: "#reputation" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 shadow-soft backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
            <i className="ri-fire-fill"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-900">
            火影同人动漫
          </span>
        </a>

        {/* Desktop nav */}
        <div className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            className="ml-3 inline-flex items-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始追更
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
          onClick={() => setMenuOpen((v) => !v)}
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="block border-b border-background-100 py-3 text-sm font-medium text-foreground-800"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex items-center justify-center rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50"
          >
            开始追更
          </a>
        </div>
      )}
    </header>
  );
}